import { render, staticRenderFns } from "./ModalProjectActivate.vue?vue&type=template&id=21dbc603&scoped=true"
import script from "./ModalProjectActivate.vue?vue&type=script&lang=js"
export * from "./ModalProjectActivate.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectActivate.vue?vue&type=style&index=0&id=21dbc603&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dbc603",
  null
  
)

export default component.exports